/*
 * Karl's answer on one finding: the verdict word, the Confidence level, a
 * style-choice hint when the guidance flags one, and the Accepted with Karl
 * mark after a bulk apply. Presentational so the panel owns every decision.
 */
import { Badge, Text } from "@fluentui/react-components";
import { useTranslation } from "../../i18n/useTranslation";
import { formatKarlVerdictBadge } from "../../karl/karlLogic";
import type { KarlVerdict } from "../../state/types";

export function KarlVerdictBadge({
  verdict,
  accepted,
}: {
  verdict: KarlVerdict;
  accepted: boolean;
}): JSX.Element {
  const { t } = useTranslation();

  return (
    <div
      className="karl-verdict-badge"
      data-karl-badge
      data-confidence={verdict.confidence}
      data-decision={verdict.decision}
    >
      <Badge appearance="filled" color={verdict.decision === "keep" ? "success" : "brand"}>
        <span aria-hidden="true">{verdict.decision === "keep" ? "✓" : "↻"}</span>
        <span>{formatKarlVerdictBadge(verdict, t)}</span>
      </Badge>
      {verdict.styleChoice ? (
        <Text size={200} className="karl-verdict-badge__hint">
          {t.karlStyleChoice}
        </Text>
      ) : null}
      {accepted ? (
        <Text size={200} className="karl-verdict-badge__accepted" data-karl-accepted>
          {t.karlAcceptedWithKarl}
        </Text>
      ) : null}
    </div>
  );
}
